import L from "leaflet";

import { DistanceUnits, HeadingUnit } from "../Features/Common/Units/types";
import { IConfig, ISettings, MapLocationTrackingBehaviour, ToolbarFlowOrientation } from "./settingsTypes";
import { coordsBgsToLatLng, crsPresets } from "../Features/MapComponents/geoUtils";

import googleMapsLayerThumb from '../assets/layerThumbs/GoogleMapsSatellite.png';
import osLeisureLayerThumb from '../assets/layerThumbs/OSLeisure27700.png';
import osOutdoorLayerThumb from '../assets/layerThumbs/OSLeisure27700.png';
import osLightLayerThumb from '../assets/layerThumbs/OSLeisure27700.png';
import osRoadLayerThumb from '../assets/layerThumbs/OSLeisure27700.png';

//Pass SVGs through https://www.svgminify.com/ first
import currentLocationWithHeadingIcon from '../assets/mapIcons/CurrentLocationWithHeading.svg';
import currentLocationNoHeadingIcon from '../assets/mapIcons/CurrentLocationNoHeading.svg';


export const config: IConfig = {

  defaultCentre: L.latLng(50.7260, -3.5275),  //Exeter

  locale: new Intl.Locale('en-GB'),

  ui: {
    placeSearchOSApiUrl: process.env.REACT_APP_PLACE_SEARCH_OS_PLACE_SEARCH_URL!,
    placeSearchMaxResults: +process.env.REACT_APP_PLACE_SEARCH_MAX_RESULTS!,
    placeHistoryMaxItems: +process.env.REACT_APP_PLACE_HISTORY_MAX_ITEMS!,
    notifierAutoHideDurationMs: 5000,
    notifierMaxItems: 1
  },
  
  tileCacheSeeder: {
    databaseName: process.env.REACT_APP_TILE_CACHE_IDB_NAME,
    operationObjectStoreName: 'ops',
    tileObjectStoreName: 'tiles',
    tileRefetchAgeDays: +process.env.REACT_APP_MAP_TILE_CACHE_REFETCH_AGE_DAYS!,///
    uiTitleOpInProgress: "Hunt Mapper - Downloading",
    operationHistoryMaxAgeDays: +process.env.REACT_APP_MAP_TILE_OP_LIFETIME_DAYS!
  },

  mapSnapshotGenerator: {
    type: 'image/png',
    quality: 0.9
  },

  maxBounds: L.latLngBounds(coordsBgsToLatLng([ -238375.0, 0.0 ]), coordsBgsToLatLng([ 900000.0, 1376256.0 ])),  //UK

  tileLayers: [
    { 
      id: 'osMapsLeisure27700',
      name: 'Ordnance Survey - Leisure',
      thumbUrl: osLeisureLayerThumb,
      urlTemplate: process.env.REACT_APP_MAP_OS_LEISURE_ZXY_URL_TEMPLATE!,
      urlSubdomains: [],
      minZoom: 0,
      maxZoom: 9,
      defaultZoom: 8,
      crs: crsPresets.OS7700,
      canDownload: true
    },
    { 
      id: 'osMapsOutdoor3857',
      name: 'Ordnance Survey - Outdoor',
      thumbUrl: osOutdoorLayerThumb,
      urlTemplate: process.env.REACT_APP_MAP_OS_OUTDOOR_ZXY_URL_TEMPLATE!,
      urlSubdomains: [],
      minZoom: 7,
      maxZoom: 18,
      defaultZoom: 16,
      crs: crsPresets.WebMercator,
      canDownload: true
    },
    {
      id: 'osMapsLight3857',
      name: 'Ordnance Survey - Light',
      thumbUrl: osLightLayerThumb,
      urlTemplate: process.env.REACT_APP_MAP_OS_LIGHT_ZXY_URL_TEMPLATE!,
      urlSubdomains: [],
      minZoom: 7,
      maxZoom: 18,
      defaultZoom: 16,
      crs: crsPresets.WebMercator,
      canDownload: true
    },
    {
      id: 'osMapsRoad3857',
      name: 'Ordnance Survey - Road',
      thumbUrl: osRoadLayerThumb,
      urlTemplate: process.env.REACT_APP_MAP_OS_ROAD_ZXY_URL_TEMPLATE!,
      urlSubdomains: [],
      minZoom: 7,
      maxZoom: 18,
      defaultZoom: 16,
      crs: crsPresets.WebMercator,
      canDownload: true
    },
    { 
      id: 'googleMapsSatellite',
      name: 'Google Satellite',
      thumbUrl: googleMapsLayerThumb,
      urlTemplate: process.env.REACT_APP_MAP_GOOGLESAT_ZXY_URL_TEMPLATE!,
      urlSubdomains: process.env.REACT_APP_MAP_GOOGLESAT_ZXY_URL_SUBDOMAINS!.split(','),
      minZoom: 7,
      maxZoom: 18,
      defaultZoom: 16,
      crs: crsPresets.WebMercator,
      canDownload: true
    }

  ],

  icons: {

    currentLocationWithHeading: {
      iconUrl: currentLocationWithHeadingIcon,
      iconSize: [50, 50], // size of the icon
      iconAnchor: [25, 25], // point of the icon which will correspond to marker's location
      tooltipAnchor: [0, 0] // point from which the tooltip should open relative to the iconAnchor
    },

    currentLocationNoHeading: {
      iconUrl: currentLocationNoHeadingIcon,
      iconSize: [50, 50], // size of the icon
      iconAnchor: [25, 25], // point of the icon which will correspond to marker's location
      tooltipAnchor: [0, 0] // point from which the tooltip should open relative to the iconAnchor
    }

  }
}

export const defaultSettings: ISettings = {

    map: {
      defaultLayerId: 'osMapsLeisure27700',
      locationTrackingBehaviour: MapLocationTrackingBehaviour.Always
    },

    tileCache: {
      activeCacheSeederId: null
    },

    ui: {
      headingUnit: HeadingUnit.Degrees,
      distanceUnits: DistanceUnits.Metric,
      toolbarFlowOrientation: ToolbarFlowOrientation.RightHanded
    },

};